module.exports = __webpack_public_path__ + "static/media/google_privacy.b4ea2adf.jpg";